import React, { useCallback, useState } from 'react';
import EddyEmbed from 'blocks/EddyEmbed';
import Modal from 'components/Modal';
import EddyEditTranscriptModalHeader from './EddyEditTranscriptModalHeader';
import { block } from './utils';

export interface EddyEditTranscriptModalContentsProps {
  eddyProjectId: string;
  onSave?: () => void;
  onCancel?: () => void;
}

const EddyEditTranscriptModalContents: React.FC<EddyEditTranscriptModalContentsProps> = ({
  eddyProjectId,
  onSave,
  onCancel,
}) => {
  const [isTranscriptLoaded, setIsTranscriptLoaded] = useState(false);

  const handleCancel = useCallback((): void => {
    setIsTranscriptLoaded(false);
    onCancel?.();
  }, [onCancel]);

  return (
    <Modal.Body className={block('contents')}>
      <EddyEditTranscriptModalHeader
        isTranscriptLoaded={isTranscriptLoaded}
        onSave={onSave}
        onCancel={handleCancel}
      />

      {eddyProjectId && (
        <EddyEmbed
          width="100%"
          height="100%"
          eddyProjectId={eddyProjectId}
          className={block('transcript')}
          onApplicationReady={() => setIsTranscriptLoaded(true)}
        />
      )}
    </Modal.Body>
  );
};

export default EddyEditTranscriptModalContents;
